import { createAction } from 'redux-actions';

export const clearInventoryExportUrl = createAction(
  'CLEAR_INVENTORY_EXPORT_URL'
);

export const setInventoryExportInProgress = createAction(
  'SET_INVENTORY_EXPORT_IN_PROGRESS'
);
